import React, { useContext, useEffect, useState, useRef } from "react";
import Typography from "@mui/material/Typography";
import { useIntl } from "react-intl";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
// mui
import { Grid, Box, IconButton } from "@mui/material";
// component
import DataTable from "./components/DataTable";
import FeedBack from "./components/FeedBack";
import AnserFeedBack from "./components/AnserFeedBack";
import BottomPanel from "./bottomPanel/BottomPanel";
import ResultsPanel from "./components/ResultsPanel/ResultsPanel";
// img
import imgAnalyzing from "../../../../../../../../../../../images/ai_image/analyzing.svg";
import imgNoResult from "../../../../../../../../../../../images/ai_image/no_result.svg";
import closeIcon from "../../../../../../../../../../../images/ai_image/closeIcon.svg";
// utils
import ApiUrls from "../../../../../../../../../../api/project/ApiUrls";
import { StoreContext } from "../../../../../../../../../../store/StoreProvider";
import Act from "../../../../../../../../../../store/actions";

import DraggableWindow from "../../../../../../../../../../common/components/draggable/DraggableWindow";
import { aiPageConfig } from "../../../../textConfig";

const ResultPage = () => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna, user } = state;
  const { isFetch, isWatchingInput, InputTxt, itemPerPage, tableData } = sna.AI;

  const intl = useIntl();
  const { uid } = user;
  const [isDataEmpty, setIsDataEmpty] = useState(false);
  const [isReturnFeedback, setIsReturnFeedback] = useState(false);
  const [isFeedBackGood, setIsFeedBackGood] = useState(null);

  function createData(
    source,
    srcId,
    srcLabel,
    dstId,
    dstLabel,
    event,
    relationship
  ) {
    return {
      id: uuidv4(),
      source,
      srcId,
      srcLabel,
      dstId,
      dstLabel,
      mainEvn: event,
      subEvn: "",
      relationship,
      Adding: false,
    };
  }

  async function handleCheck() {
    try {
      const response = await axios.post(ApiUrls.getAICheck(), {
        username: uid,
      });
      if (response.status === 200) {
        localStorage.setItem("AIFetch", false);
        const newtableData = response.data.map((data) =>
          createData(
            data.source,
            data.srcId,
            data.srcLabel,
            data.dstId,
            data.dstLabel,
            data.event,
            data.relationship
          )
        );

        dispatch({
          type: Act.SNA_SET_AI_TABLE_DATA,
          payload: newtableData,
        });
        dispatch({
          type: Act.SNA_SET_AI_TABLE_TOTAL_PAGE,
          payload: Math.ceil(newtableData.length / itemPerPage),
        });
        dispatch({
          type: Act.SNA_SET_AI_TABLE_CURRENT_PAGE,
          payload: 1,
        });
        dispatch({
          type: Act.SNA_SET_AI_IS_FETCH_DATA,
          payload: false,
        });
        dispatch({
          type: Act.SNA_SET_AI_FETCH_DATA,
          payload: response.data,
        });

        if (response.data.length === 0) {
          setIsDataEmpty(true);

          dispatch({
            type: Act.SNA_SET_AI_TABLE_DATA,
            payload: [],
          });
        } else {
          setIsDataEmpty(false);
        }
      } else if (response.status === 202) {
        localStorage.setItem("AIFetch", false);
        setIsDataEmpty(true);

        dispatch({
          type: Act.SNA_SET_AI_TABLE_DATA,
          payload: [],
        });
        dispatch({
          type: Act.SNA_SET_AI_IS_FETCH_DATA,
          payload: false,
        });
        dispatch({ type: Act.SNA_SET_AI_FETCH_DATA, payload: "" });
      } else if (response.status === 201) {
        return;
      }
    } catch (e) {
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          content: "Fail to Fetch data",
        },
      });
    }
  }

  useEffect(() => {
    if (isFetch) {
      const intervalID = setInterval(handleCheck, 3000);
      return () => clearInterval(intervalID);
    }
    return false;
  }, [isFetch]);

  useEffect(() => {
    dispatch({
      type: Act.SNA_SET_AI_TABLE_TOTAL_PAGE,
      payload: Math.ceil(tableData.length / itemPerPage),
    });
  }, [tableData]);

  const closeDragWindow = () => {
    dispatch({
      type: Act.SNA_SET_AI_IS_WATCHING_INPUT,
      payload: false,
    });
  };

  const getElement = () => (
    <Box style={{ height: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span
          style={{
            fontSize: "16px",
            fontWeight: "700",
          }}
        >
          全文預覽
        </span>
        <IconButton
          type="button"
          sx={{ padding: 0 }}
          onTouchStart={closeDragWindow}
          onClick={closeDragWindow}
        >
          <img src={closeIcon} alt="" />
        </IconButton>
      </Box>
      <p
        style={{
          height: "calc(100% - 57px)",
          overflowY: "auto",
          fontSize: "14px",
          fontWeight: "400",
        }}
      >
        {InputTxt}
      </p>
    </Box>
  );

  return (
    <Grid
      container
      sx={{
        // height: { xs: "76vh", xl: "85vh" },
        backgroundColor: "#FFFFFF",
        padding: "16px 24px 24px 24px",
        marginTop: "16px",
        // height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Grid container>
        <ResultsPanel btnShow={!isFetch} title="2. 分析結果" />
        <Grid sx={{ width: "100%" }}>
          {/* eslint-disable-next-line no-nested-ternary */}
          {isFetch ? (
            <Box
              sx={{ maxWidth: "100%", height: "60vh" }}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography fontWeight="700" fontSize={20}>
                {intl.formatMessage({
                  id: "sna.sidetool.digitalAITool.ai.AIanalyze.title",
                  defaultMessage: "正在語意分析中，請稍候...",
                })}
              </Typography>
              <img
                src={imgAnalyzing}
                alt="analyzing"
                style={{ height: "70%" }}
              />
              <Typography
                fontWeight="400"
                fontSize={16}
                style={{ textAlign: "center" }}
              >
                {intl.formatMessage({
                  id: "sna.sidetool.digitalAITool.ai.AIanalyze.content",
                  defaultMessage:
                    "感謝您使用「AI語意分析」！分析需花費3至5分鐘。等待期間，您可以探索其他功能或瀏覽內容，讓我們的AI在背景中為您進行分析。",
                })}
              </Typography>
            </Box>
          ) : isDataEmpty ? (
            <Box
              sx={{
                maxWidth: "100%",
                height: "60vh",
                textAlign: "center",
              }}
            >
              <Typography fontWeight="700" fontSize={20}>
                {intl.formatMessage({
                  id: "sna.sidetool.digitalAITool.ai.AIanalyzeEmpty.title",
                  defaultMessage: "文字段落中無任何關聯",
                })}
              </Typography>
              <img
                src={imgNoResult}
                alt="no result"
                style={{ height: "100%" }}
              />
            </Box>
          ) : (
            <Grid>
              <Box position="relative">
                {isWatchingInput && (
                  <Box position="absolute" right={0} top={0} zIndex={10}>
                    <DraggableWindow
                      element={getElement()}
                      rndDefault={{
                        width: "65vh",
                        height: "65vh",
                        x: 0 - window.innerHeight * 0.65,
                        y: 0,
                      }}
                      boundingBoxClassName=".DigitalAITool__AI"
                    />
                  </Box>
                )}
                <DataTable header={aiPageConfig.tableDataHeaderCh} />
              </Box>
              {isReturnFeedback ? (
                <AnserFeedBack isFeedBackGood={isFeedBackGood} />
              ) : (
                <FeedBack
                  setIsReturnFeedback={setIsReturnFeedback}
                  setIsFeedBackGood={setIsFeedBackGood}
                />
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
      <BottomPanel
        dispatch={dispatch}
        isFetch={isFetch}
        isDataEmpty={isDataEmpty}
      />
    </Grid>
  );
};

export default ResultPage;
